import { Link } from 'react-router-dom'

const sections = [
  {
    title: 'Vilken data vi samlar in',
    content: [
      'E-postadress för kontoinloggning och aviseringar.',
      'Föräldrars namn för att visa i appen och i gruppsammanhang.',
      'Barnens namn och ålder för att matcha uppdrag och framsteg.',
      'Uppladdade bilder eller videor kopplade till uppdrag ni godkänner.',
      'Loggar över genomförda uppdrag och XP för familjens historik.'
    ]
  },
  {
    title: 'Hur vi använder datan',
    content: [
      'Endast för att driva tjänsten, visa familjens framsteg och möjliggöra kommunikation i grupper.',
      'Vi säljer aldrig din data till tredje part och delar bara när du själv väljer att posta i grupper.'
    ]
  },
  {
    title: 'Dina rättigheter',
    content: [
      'Du kan exportera all din data från den inloggade vyn (Inställningar → Dataexport).',
      'Du kan radera ditt konto permanent under Familj → Farlig zon efter extra bekräftelse.'
    ]
  },
  {
    title: 'Barn och GDPR',
    content: [
      'Föräldern eller målsman ansvarar för att inhämta samtycke för barn under 13 år när kontot registreras och när media delas.'
    ]
  },
  {
    title: 'Kontakt',
    content: [
      'Kontakta oss på gdpr@grannaventyret.se om du har frågor kring integritet, rättigheter eller incidenter.'
    ]
  },
  {
    title: 'Cookies',
    content: [
      'Vi använder en session-cookie för att hålla dig inloggad. Den innehåller ingen spårning och försvinner när du loggar ut.'
    ]
  }
]

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0B1220] text-white">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col px-4 py-10 sm:px-6 lg:px-8">
        <header className="mb-10 text-center">
          <p className="text-sm uppercase tracking-[0.4em] text-white/50">Grannäventyret</p>
          <h1 className="mt-4 text-4xl font-bold">Integritetspolicy</h1>
          <p className="mt-3 text-base text-white/70">
            Hur vi hanterar familjens data, barns information och dina rättigheter enligt GDPR.
          </p>
        </header>

        <div className="flex-1 space-y-8 rounded-3xl bg-white/5 p-6 shadow-2xl shadow-black/30 ring-1 ring-white/10 backdrop-blur">
          {sections.map((section) => (
            <div key={section.title} className="border-b border-white/10 pb-6 last:border-0 last:pb-0">
              <h2 className="text-xl font-semibold">{section.title}</h2>
              <div className="mt-3 space-y-3 text-sm text-white/80">
                {section.content.map((line, idx) => (
                  <p key={idx}>{line}</p>
                ))}
                {section.title === 'Dina rättigheter' && (
                  <div className="text-xs text-white/60">
                    Exportlänken syns efter inloggning och radering finns under familjens inställningar.
                  </div>
                )}
              </div>
            </div>
          ))}

          <div className="pt-4 text-sm text-white/70">
            <p>Senast uppdaterad: {new Date().toLocaleDateString('sv-SE')}</p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 text-sm text-white/70">
          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 text-white/80 hover:text-white"
          >
            <span aria-hidden="true">←</span>
            Tillbaka
          </button>
          <Link to="/" className="text-white/60 hover:text-white">Till startsidan</Link>
        </div>
      </div>
    </div>
  )
}
